import React, { Component } from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { ButtonIcon } from 'components/button';
import { I18n, translate } from 'components/translate';
import { QuizService } from 'modules/content/quiz';
import ProfileEditorComponent from 'modules/content/quiz/components/editor/ProfileEditorComponent';
import ProfileImageUpload from 'modules/content/quiz/components/uploader/ProfileImageUpload';
import PropTypes from 'prop-types';

@translate()
export default class DraggableProfileComponent extends Component {
  static propTypes = {
    item: PropTypes.object,
    index: PropTypes.number,
    labels: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    t: PropTypes.func,
    type: PropTypes.string,
    onItemsChange: PropTypes.func,
    images: PropTypes
  };

  state = {
    item: this.props.item || {},
    labels: this.props.labels
  };

  get images() {
    const { images = [] } = this.props;
    const { item } = this.state;
    const profileId = item.temporaryId || item.id;

    return images.filter((image) => image.profileId === profileId);
  }

  getSnapshotBeforeUpdate() {
    if (JSON.stringify(this.state.item) !== JSON.stringify(this.props.item)) {
      return { item: this.props.item };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.setState(snapshot);
    }
  }

  createActions = (index) => {
    return (
      <div className="actions-wrapper action-wrapper-profile">
        <ButtonIcon
          className="btn-quiz-action"
          transparent
          type="secondary"
          icon="duplicate"
          onClick={(e) => this.duplicateProfile(e, index)}
        >
          <I18n label="general.duplicate" />
        </ButtonIcon>
        <ButtonIcon
          className="btn-quiz-action"
          transparent
          type="secondary"
          icon="delete"
          onClick={(e) => this.removeProfile(e, index)}
        >
          <I18n label="general.remove" />
        </ButtonIcon>
      </div>
    );
  };

  removeProfile = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    QuizService.removeProfile(index);
  };

  duplicateProfile = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const createdProfile = QuizService.duplicateProfile(index);

    setTimeout(() => {
      this.focusDuplicatedProfile(createdProfile);
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 500);
  };

  focusDuplicatedProfile = (id) => {
    const profileEl = document.getElementsByClassName('draggable-profiles')[id];

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    window.scrollTo(profileEl.offset, 1000);
    profileEl.querySelector('.ql-editor').focus();
  };

  render() {
    const { index, type } = this.props;
    const { item } = this.state;

    const customClassName = `profile-${item.id}`;
    const customDescriptionClassName = `${customClassName} description-editor`;

    return (
      <Draggable
        key={`${type}-${item.id}`}
        type={type}
        draggableId={`${type}-${item.id}`}
        id={item.id}
        index={index}
      >
        {(provided) => (
          <div key={item.id} className={`draggable-${type}`}>
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              className={`rc-quiz-container ${type}`}
            >
              <span {...provided.dragHandleProps} className="drag-handler">
                <span></span>
                <span></span>
                <span></span>
              </span>
              <div className="rc-quiz-content-wrapper">
                <li className="rc-quiz-content">
                  <ProfileEditorComponent
                    charLimit={100}
                    placeholder={this.props.t('quiz_editor.new_profile')}
                    content={item.name}
                    profileId={index}
                    className={customClassName}
                    type="name"
                  ></ProfileEditorComponent>
                  <ProfileEditorComponent
                    charLimit={500}
                    placeholder={this.props.t('quiz_editor.new_description')}
                    content={item.description}
                    profileId={index}
                    className={customDescriptionClassName}
                    type="description"
                  ></ProfileEditorComponent>
                  <ProfileImageUpload
                    {...this.props}
                    profileId={item.id}
                    images={this.images}
                  />
                </li>
                {this.createActions(index)}
              </div>
            </div>
            {provided.placeholder}
          </div>
        )}
      </Draggable>
    );
  }
}
